import {
    EmployeesService,
    IAccount,
    IShift,
    ShiftService,
    ITeam,
    Masterdata,
    IEmployee
} from '../../services';
import * as moment from "moment";
import { AuthService } from "../../authorization/services/index";
import { AccountsService } from '../../services/accounts.service';
import { IEmployeeAvailability } from '../../services/employeeAvailability.service';

interface IResolve {
    shift: IShift;
    accounts: IAccount[];
    functions: Masterdata[];
    employees: IEmployee;
    statuses: Masterdata[];
}

class ShiftItemController implements ng.IComponentController {
    private onChange: any;
    private employees: any;
    private functions: Masterdata[];
    private statuses: Masterdata[];
    private accounts: IAccount[];
    private locations: any;
    private teams: ITeam[];
    private currentAccount: IAccount;
    private currentLocation: any;
    private resolve: IResolve;
    private shift: IShift;
    private employeeNote: string;
    private employeeAvailability: IEmployeeAvailability[];
    private selectedEmployee: any;
    private mode: string;

    private sortType: string;

    constructor(
        private ShiftService: ShiftService,
        private EmployeesService: EmployeesService,
        private AccountsService: AccountsService,
        private AuthService: AuthService,
        private $stateParams: ng.ui.IStateParamsService,
        private $state: ng.ui.IStateService,
        private $timeout: ng.ITimeoutService,
        private $scope: ng.IScope,
        private SweetAlert: any
    ) {
        'ngInject';
    }

    public $onInit = () => {
        this.sortType = 'start';
        //this.onChange({type: 'open', data: ''});

        this.shift = this.resolve.shift;
        this.accounts = this.resolve.accounts;
        this.functions = this.resolve.functions;
        this.statuses = this.resolve.statuses;
        this.employees = this.resolve.employees;
        if(!this.employees.find(e => e.displayName ===  '--- Geen ---')){
            var emp = new IEmployee();
            emp.displayName = '--- Geen ---';
            this.employees.push(emp);
        }
    
        if (this.shift) {
            this.shift.start = new Date(this.shift.start);
            this.shift.end = new Date(this.shift.end);

            if (moment().isAfter(this.shift.start)) {
                this.shift.isInThePast = true;
            }
        } else {
            this.shift = new IShift();
            this.shift.start = this.roundMinutes(new Date());
            this.shift.end = moment(this.shift.start).add(8, 'hour').toDate();
            if (this.AuthService.hasRole('customer')) {
                this.shift.status = 6;
            }

            // console.log(this.$stateParams['status']);
            if (this.$stateParams['status']) {
                this.shift.status = this.$stateParams['status'];
            }

            this.shift.employeeId = null;
            this.shift.isSleepShift = false;
        }

        // console.log(this.AuthService.getTokenData().customerId);
        if (this.AuthService.hasRole('customer')) {
            this.shift.teamLocationAccountId = this.AuthService.getTokenData().customerId;
        }

        if (this.shift.teamLocationAccountId) {
            this.loadAccountSleepShiftContext(this.shift.teamLocationAccountId);
            this.AccountsService.getChild(this.shift.teamLocationAccountId, 'locations').then((result) => {
                this.locations = result;
                if (this.shift.teamLocationId) {
                    this.currentLocation = this.locations.find(item => item.id === this.shift.teamLocationId);
                    this.teams = this.currentLocation ? this.currentLocation.teams : [];
                }
            });
        }


    }

    roundMinutes(date) {
        var coeff = 1000 * 60 * 15;
        return new Date(Math.round(date.getTime() / coeff) * coeff);
    }

    startDateBeforeRender($dates) {
    }

    endDateBeforeRender($view, $dates) {
        // console.log('endDateBeforeRender');
        if (this.shift.start) {
            var activeDate = moment(this.shift.start).subtract(1, $view).add(1, 'minute');

            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    }

    public selectedAccount() {
        this.currentLocation = null;
        this.teams = [];
        this.shift.teamLocationId = null;
        this.shift.teamId = null;
        this.loadAccountSleepShiftContext(this.shift.teamLocationAccountId);
        this.AccountsService.getChild(this.shift.teamLocationAccountId, 'locations').then((result) => {
            this.locations = result;
        });
    }

    public locationSelected() {
        this.currentLocation = this.locations.find(item => item.id === this.shift.teamLocationId);
        this.teams = this.currentLocation ? this.currentLocation.teams : [];
    }

    private loadAccountSleepShiftContext = (accountId) => {
        if (!accountId) {
            this.currentAccount = null;
            return;
        }
        this.AccountsService.get(accountId).then((account: IAccount) => {
            this.currentAccount = account;
        });
    }

    public showSleepShiftOption = (): boolean => {
        if (this.shift && this.shift.sleepShiftOrtRulesActive) {
            return true;
        }
        return this.isSleepShiftOrtRulesActive();
    }

    private isSleepShiftOrtRulesActive = (): boolean => {
        if (!this.currentAccount) {
            return false;
        }

        const override = Number(this.currentAccount.sleepShiftOrtRulesOverride || 0);
        if (override === 2) {
            return false;
        }
        if (override === 1) {
            return true;
        }

        const locationCao = this.currentLocation && this.currentLocation.salaryScaleGroup;
        const accountCao = this.currentAccount.salaryScaleGroup;
        const cao = locationCao || accountCao;
        return !!(cao && cao.enableSleepShiftOrtRules);
    }

    private spansMidnight = (): boolean => {
        if (!this.shift || !this.shift.start || !this.shift.end) {
            return false;
        }
        return !moment(this.shift.start).isSame(moment(this.shift.end), 'day');
    }

    private askSleepShiftIfOvernight = (continueSave) => {
        if (this.shift.isSleepShift || !this.showSleepShiftOption() || !this.spansMidnight()) {
            continueSave();
            return;
        }

        this.SweetAlert.swal({
            title: 'Slaapdienst?',
            text: 'Deze dienst loopt over middernacht. Is dit een slaapdienst? (bereikbaarheid ’s nachts, geen ORT op slaapuren)',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Ja, slaapdienst',
            cancelButtonText: 'Nee, gewone nachtdienst'
        }, (isConfirm) => {
            if (isConfirm) {
                this.shift.isSleepShift = true;
            }
            continueSave();
        });
    }

    public submitShift(after = null) {
        if (this.shift.isInThePast) {
            this.SweetAlert.swal({
                title: 'Let op!',
                text: 'Deze dienst is in het verleden. Weet je zeker dit zeker?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#2ECC71',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ja, opslaan',
                cancelButtonText: 'Nee, annuleren',
            }, (isConfirm) => {
                if (isConfirm) {
                    this.save(after);
                } else {

                }
            });
        } else {
            this.save(after);
        }

    }

    save(after) {
        if (moment(this.shift.start).isAfter(this.shift.end)) {
            this.SweetAlert.swal({
                title: 'Let op!',
                text: 'Eindtijd ligt voor starttijd',
                type: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#2ECC71',
                cancelButtonColor: '#d33',
                confirmButtonText: 'OK',
            }, (isConfirm) => {
                if (isConfirm) {

                }
            });
        } else {
            this.askSleepShiftIfOvernight(() => this.persistShift(after));
        }
    }

    persistShift(after) {
        this.shift.start = moment(this.shift.start).format("YYYY-MM-DD HH:mm");
        this.shift.end = moment(this.shift.end).format("YYYY-MM-DD HH:mm");
        if (!this.shift.id) {
            this.ShiftService.post(this.shift).then((data) => {
                this.shift = data;
                this.handleAfterSubmit(after);
            });
        } else {
            this.ShiftService.put(this.shift.id, this.shift).then((data) => {
                this.handleAfterSubmit(after);
            });
        }
    }

    deleteShift() {
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u deze dienst wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, (isConfirm) => {
            if (isConfirm) {
                this.ShiftService.delete(this.shift.id).then(() => {
                    // this.shifts = this.shifts.filter(s => s.id !== this.shift.id);
                    this.shift = null;
                    this.closeModal();
                });
            } else {
            }
        });
    }

    handleAfterSubmit(after) {
        switch (after) {
            case "copy": {
                this.shift.id = null;
                this.shift.start = moment(this.shift.start).add(1, 'day').toDate();
                this.shift.end = moment(this.shift.end).add(1, 'day').toDate();
                if (moment().isAfter(this.shift.start)) {
                    this.shift.isInThePast = true;
                } else {
                    this.shift.isInThePast = false;
                }
                break;
            }
            case "new": {
                this.shift = new IShift();
                break;
            }
            default: {
                this.closeModal();
            }
        }
    }

    private closeModal() {
        if (this.shift && this.shift.id) {
            this.$state.go('^', { 'id': this.shift.id }, { reload: true });
        } else {
            this.$state.go('^', { 'id': null }, { reload: true });
        }
    }
}

export const shiftItemComponent: ng.IComponentOptions = {
    bindings: {
        resolve: '<',
        //onChange: '&',
    },
    controller: ShiftItemController,
    template: <string>require('./shift.item.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/shifts/shift.item.component.ts